import React from "react";
import { FaDiscord, FaTelegramPlane, FaTwitter } from "react-icons/fa";
import { IconContext } from "react-icons";

export default function navbarItems() {
  return (
    <div>
      <a
        href="https://app.senseifi.io"
        target="_blank"
        className="text-lg py-5  border-b border-white"
      >
        Launch Dapp
      </a>
      <div className="my-20 flex gap-10">
        <IconContext.Provider value={{ className: "text-2xl" }}>
          <a href="https://t.me/SenSeiFi">
            <FaTelegramPlane />
          </a>
        </IconContext.Provider>
        <IconContext.Provider value={{ className: "text-2xl" }}>
          <a href="https://twitter.com/SenSei_DeFi">
            <FaTwitter />
          </a>
        </IconContext.Provider>
        <IconContext.Provider value={{ className: "text-2xl" }}>
          <a href="https://discord.gg/b6h3paCYy4">
            <FaDiscord />
          </a>
        </IconContext.Provider>
      </div>
    </div>
  );
}
